import JsonDecodeInput from './JsonDecodeInput';

const filter = {
  name: 'JSON decode',
  Input: JsonDecodeInput,
  content: {},
  format: (variable) => {
    return `${variable}|json_decode`;
  },
  valid: () => true
};

export default filter;
